import React, { useEffect, useState, useRef } from "react";
import MapsSearch from "./MapsSearch";
import UserProfile from "../../common/UserProfile";
import Compass from "./Compass";
import BaseMaps from "./BaseMaps";
import ZoomMaps from "./ZoomMaps";
import CurrentPosition from "./CurrentPosition";
import { UserJson } from "../../layout/Header";
import maplibregl from "maplibre-gl";
import type { FeatureCollection } from "geojson";
import MeasureDistance from "./MeasureDistance";
import HotSpotStatus from "../../common/HotSpotStatus";
import { GiHamburgerMenu } from "react-icons/gi";
import _ from "lodash";
import { useNavbar } from "../../../context/NavBarContext";
import {
  // FilterTypeProps,
  useFilterMap,
} from "../../../context/FilterMapContext";
// import axios from "axios";
import { formatUnixDateToThai } from "../../../utils/common";

function Maps() {
  const userJson = localStorage.getItem("user");
  const [user, setUser] = useState<UserJson>();
  const [mapLibre, setMapLibre] = useState<any>(null);
  const [measurementEnabled, setMeasurementEnabled] = useState(false);
  const mapContainer = useRef<any>(null);
  const [zoom, setZoom] = useState<number>(6);
  const [currentPosition, setCurrentPosition] = useState<any>([]);
  const [featurePoint, setFeaturePoint] = useState<any>();
  const [distance, setDistance] = useState<number | undefined>();
  // const [hotspotSurvey, setHotspotSurvey] = useState<any>({
  //   type: "FeatureCollection",
  //   features: [],
  // });
  const { isOpen, toggleNavbar } = useNavbar();
  const [angle, setAngle] = useState(0);
  const { filterMap, baseMapUrl } = useFilterMap();
  const [coordinatePoint, setCoordinatePoint] = useState();
  const [layers, setLayers] = useState<any>();
  const [satelliteLayer, setSatelliteLayer] = useState<any>();

  const [openHotSpotStatus, setOpenHotSpotStatus] = useState(false);
  const [isHideStatusBar, setIsHideStatusBar] = useState(false);
  // const [filterConditionArea, setFilterConditionArea] = useState([
  //   ["==", ["get", "lu_code"], 1],
  //   ["==", ["get", "lu_code"], 2],
  //   ["==", ["get", "lu_code"], 3],
  //   ["==", ["get", "lu_code"], 4],
  //   ["==", ["get", "lu_code"], 5],
  //   ["==", ["get", "lu_code"], 6],
  //   ["!=", ["get", "ct_en"], "Thailand"],
  // ]);
  // const accessToken = localStorage.getItem("access_token");
  // const [formId, setFormId] = useState("");
  // const [surveyReference, setSurveyReference] = useState<any>();
  // const [surveyResponse, setSurveyResponse] = useState<any>();
  // const [filterSatelliteViirs, setFilterSatelliteViirs] = useState([
  //   ["!=", ["get", "satellite"], "NOAA-20"],
  //   ["!=", ["get", "satellite"], "Suomi NPP"],
  // ]);
  // const [filterMaps, setFilterMaps] = useState<FilterTypeProps>({
  //   openVIIRS: true,
  //   openNPP: true,
  //   openNORR: true,
  //   openModis: false,
  //   openALRO: true,
  //   openAgriculture: true,
  //   openProtectedForest: true,
  //   openConservedForest: true,
  //   openHighway: true,
  //   openVillage: true,
  //   openOtherCountry: true,
  //   openProvice: false,
  //   openDistrict: false,
  //   openSubDistrict: false,
  // });
  const [unixDateToday, setUnixDateToday] = useState<number>();
  const [unixDateThirtyAgo, setUnixDateThirtyAgo] = useState<number>();

  const [geoCurrentPosition, setGeoCurrentPosition] =
    useState<FeatureCollection>({
      type: "FeatureCollection",
      features: [
        {
          id: "64f587dc56c57d51de110850",
          type: "Feature",
          geometry: { type: "Point", coordinates: currentPosition },
          properties: {},
        },
      ],
    });
  const [geoMeasurePoint, setGeoMeasurePoint] = useState<any>({
    type: "FeatureCollection",
    features: [],
  });
  const [geoMeasureLine, setGeoMeasureLine] = useState<any>({
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: [],
    },
  });
  const geoLocationControll = () => {
    let isHaveLayer = mapLibre?.getSource("current-position");
    if (isHaveLayer) {
      mapLibre?.flyTo({
        center: currentPosition,
        zoom: 10,
        essential: true,
      });
    }
  };
  const getCurrentPosition = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      setCurrentPosition([longitude, latitude]);
      setGeoCurrentPosition({
        type: "FeatureCollection",
        features: [
          {
            id: "64f587dc56c57d51de110850",
            type: "Feature",
            geometry: { type: "Point", coordinates: [longitude, latitude] },
            properties: {},
          },
        ],
      });
    });
  };
  const handleRotateMap = () => {
    mapLibre?.flyTo({
      bearing: 0,
      pitch: 0,
      essential: true,
    });
  };
  const handleSelectPosition = (value: number[]) => {
    if (value.length < 2) {
      return;
    }
    mapLibre?.flyTo({
      center: value,
      zoom: 10,
      essential: true,
    });
  };
  const handleMeasurementDistance = (e: any) => {
    if (measurementEnabled) {
      const features = mapLibre.queryRenderedFeatures(e.point, {
        layers: ["measure-points"],
      });
      const updatedGeoJSONPoint = { ...geoMeasurePoint };
      const updatedGeoJSONLine = { ...geoMeasureLine };

      if (features && features.length > 0) {
        return;
      } else {
        const point = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [e.lngLat.lng, e.lngLat.lat],
          },
          properties: {
            id: String(new Date().getTime()),
          },
        };
        updatedGeoJSONPoint.features.push(point);
      }

      updatedGeoJSONLine.geometry.coordinates.push([
        e.lngLat.lng,
        e.lngLat.lat,
      ]);

      setGeoMeasurePoint(updatedGeoJSONPoint);
      setGeoMeasureLine(updatedGeoJSONLine);
    }
  };
  const handleMouseMove = (e: any) => {
    if (!mapLibre) return;
    if (measurementEnabled) {
      const features = mapLibre.queryRenderedFeatures(e.point, {
        layers: ["measure-points"],
      });
      mapLibre.getCanvas().style.cursor = features.length
        ? "pointer"
        : "crosshair";
    }
  };
  const handleMeasureMentToggle = () => {
    if (measurementEnabled) {
      handleClearMeasureLayer();
      setGeoMeasurePoint({
        type: "FeatureCollection",
        features: [],
      });
      setGeoMeasureLine({
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: [],
        },
      });
    }
    setMeasurementEnabled(!measurementEnabled);
  };
  const handlePopMeasurePoint = () => {
    if (measurementEnabled) {
      const updatedGeoJSONPoint = { ...geoMeasurePoint };
      const updatedGeoJSONLine = { ...geoMeasureLine };

      if (
        updatedGeoJSONPoint.features.length <= 0 ||
        updatedGeoJSONLine.geometry.coordinates.length <= 0
      )
        return;

      updatedGeoJSONPoint.features.pop();
      updatedGeoJSONLine.geometry.coordinates.pop();

      setGeoMeasurePoint(updatedGeoJSONPoint);
      setGeoMeasureLine(updatedGeoJSONLine);
    }
  };
  const handleCalculateDistance = (coordinates: any) => {
    if (coordinates.length <= 0) {
      setDistance(undefined);
    }
    if (coordinates.length === 1) {
      setDistance(0);
    }
    let cumulativeDistance = 0;
    var turf = require("@turf/turf");

    for (let i = 1; i < coordinates.length; i++) {
      const [lat1, lon1] = coordinates[i - 1];
      const [lat2, lon2] = coordinates[i];

      const from = turf.point([lat1, lon1]);
      const to = turf.point([lat2, lon2]);
      const options = { units: "kilometers" };

      const distance = turf.distance(from, to, options);
      cumulativeDistance = cumulativeDistance + distance;
      setDistance(cumulativeDistance);
    }
  };
  const handleAddMeasurementLayer = () => {
    if (!mapLibre) return;
    if (measurementEnabled) {
      handleClearMeasureLayer();
      mapLibre.addSource("geo-measure", {
        type: "geojson",
        data: geoMeasurePoint,
      });
      mapLibre.addSource("geojson-line", {
        type: "geojson",
        data: geoMeasureLine,
      });
      mapLibre.addLayer({
        id: "measure-points-background",
        type: "circle",
        source: "geo-measure",
        paint: {
          "circle-radius": 16,
          "circle-color": "#C34A25",
          "circle-opacity": 0.2,
        },
        filter: ["in", "$type", "Point"],
      });
      mapLibre.addLayer({
        id: "measure-lines",
        type: "line",
        source: "geojson-line",
        paint: {
          "line-color": "#C34A25",
          "line-width": 1.5,
          "line-dasharray": [2, 1],
        },
        filter: ["in", "$type", "LineString"],
      });
      mapLibre.addLayer({
        id: "measure-points",
        type: "circle",
        source: "geo-measure",
        paint: {
          "circle-radius": 5,
          "circle-color": "#C34A25",
        },
        filter: ["in", "$type", "Point"],
      });

      mapLibre.on("click", handleMeasurementDistance);
      mapLibre.on("mousemove", handleMouseMove);
    }
  };
  const handleClearMeasureLayer = () => {
    mapLibre.getLayer("measure-points") &&
      mapLibre.removeLayer("measure-points");
    mapLibre.getLayer("measure-lines") && mapLibre.removeLayer("measure-lines");
    mapLibre.getLayer("measure-points-background") &&
      mapLibre.removeLayer("measure-points-background");
    mapLibre.getSource("geo-measure") && mapLibre.removeSource("geo-measure");
    mapLibre.getSource("geojson-line") && mapLibre.removeSource("geojson-line");
  };
  const handleCheckBaseMap = (map: string) => {
    if (map === "satellite") {
      _.map(satelliteLayer, (layer) => {
        if (layer.metadata["vallaris:group"] === "Satellite") {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
        } else {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
        }
      });
    }
    if (map === "topography") {
      _.map(satelliteLayer, (layer) => {
        if (layer.metadata["vallaris:group"] === "Topography") {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
        } else {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
        }
      });
    }
    if (map === "hybrid") {
      _.map(satelliteLayer, (layer) => {
        if (layer.metadata["vallaris:group"] === "Hybrid") {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
        } else {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
        }
      });
    }
  };
  const handleFilterMap = (filterMap: any) => {
    let conditionFilter = [];
    if (filterMap.openProtectedForest) {
      conditionFilter.push(["==", ["get", "lu_code"], 1]);
    }
    if (filterMap.openALRO) {
      conditionFilter.push(["==", ["get", "lu_code"], 2]);
    }
    if (filterMap.openConservedForest) {
      conditionFilter.push(["==", ["get", "lu_code"], 3]);
    }
    if (filterMap.openHighway) {
      conditionFilter.push(["==", ["get", "lu_code"], 4]);
    }
    if (filterMap.openAgriculture) {
      conditionFilter.push(["==", ["get", "lu_code"], 5]);
    }
    if (filterMap.openVillage) {
      conditionFilter.push(["==", ["get", "lu_code"], 6]);
    }
    if (filterMap.openOtherCountry) {
      conditionFilter.push(["!=", ["get", "ct_en"], "Thailand"]);
    }

    if (filterMap.openVIIRS) {
      if (filterMap.openNPP) {
        let filter = [
          "all",
          ["any", ...conditionFilter],
          ["==", ["get", "instrument"], "VIIRS"],
          ["==", ["get", "satellite"], "Suomi NPP"],
        ];
        _.map(layers, (layer) => {
          if (layer?.id === "viirs-data-Suomi_NPP") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          }
        });
        mapLibre?.setFilter("viirs-data-Suomi_NPP", filter);
      } else {
        _.map(layers, (layer) => {
          if (layer?.id === "viirs-data-Suomi_NPP") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
          }
        });
      }

      if (filterMap.openNORR) {
        let filter = [
          "all",
          ["any", ...conditionFilter],
          ["==", ["get", "instrument"], "VIIRS"],
          ["==", ["get", "satellite"], "NOAA-20"],
        ];
        _.map(layers, (layer) => {
          if (layer?.id === "viirs-data-NOAA-20") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          }
        });
        mapLibre?.setFilter("viirs-data-NOAA-20", filter);
      } else {
        _.map(layers, (layer) => {
          if (layer?.id === "viirs-data-NOAA-20") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
          }
        });
      }
    } else {
      _.map(layers, (layer) => {
        if (
          layer?.id === "viirs-data-NOAA-20" ||
          layer?.id === "viirs-data-Suomi_NPP"
        ) {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
        }
      });
    }
    if (filterMap.openModis) {
      let filter = [
        "all",
        ["any", ...conditionFilter],
        ["==", ["get", "instrument"], "MODIS"],
      ];
      _.map(layers, (layer) => {
        if (layer?.id === "modis-data") {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
        }
      });
      mapLibre?.setFilter("modis-data", filter);
    } else {
      _.map(layers, (layer) => {
        if (layer?.id === "modis-data") {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
        }
      });
    }
  };
  const handleCheckZoomLevel = () => {
    mapLibre?.on("zoom", () => {
      let currentZoom = mapLibre.getZoom().toFixed(0);
      setZoom(currentZoom);
    });
  };
  const handleCheckAngle = () => {
    mapLibre.on("rotate", () => {
      let currentRotation = mapLibre.getBearing().toFixed(0);
      setAngle(currentRotation);
    });
  };
  const handleZoomMap = (zoomLevel: number) => {
    mapLibre.easeTo({
      zoom: zoomLevel,
      essential: true,
    });
  };
  // const handleSetFilterMaps = (value: FilterTypeProps) => {
  //   let rawCondition = [];
  //   // let rawSatellite = [];
  //   if (value.openProtectedForest) {
  //     rawCondition.push(["==", ["get", "lu_code"], 1]);
  //   }
  //   if (value.openALRO) {
  //     rawCondition.push(["==", ["get", "lu_code"], 2]);
  //   }
  //   if (value.openConservedForest) {
  //     rawCondition.push(["==", ["get", "lu_code"], 3]);
  //   }
  //   if (value.openHighway) {
  //     rawCondition.push(["==", ["get", "lu_code"], 4]);
  //   }
  //   if (value.openAgriculture) {
  //     rawCondition.push(["==", ["get", "lu_code"], 5]);
  //   }
  //   if (value.openVillage) {
  //     rawCondition.push(["==", ["get", "lu_code"], 6]);
  //   }
  //   if (value.openOtherCountry) {
  //     rawCondition.push(["!=", ["get", "ct_en"], "Thailand"]);
  //   }
  //   // if (!value.openNORR && !value.openNPP) {
  //   //   rawSatellite.push(["!=", ["get", "satellite"], "NOAA-20"]);
  //   //   rawSatellite.push(["!=", ["get", "satellite"], "Suomi NPP"]);
  //   // }
  //   // if (value.openNORR) {
  //   //   rawSatellite.push(["==", ["get", "satellite"], "NOAA-20"]);
  //   // }
  //   // if (value.openNPP) {
  //   //   rawSatellite.push(["==", ["get", "satellite"], "Suomi NPP"]);
  //   // }

  //   if (value.openVIIRS) {
  //     setFilterConditionArea(rawCondition);
  //     // setFilterSatelliteViirs(rawSatellite);
  //   } else {
  //     setFilterConditionArea(rawCondition);
  //   }

  //   setFilterMaps(value);
  // };
  // const handleMouseMoveSatelliteData = () => {
  //   mapLibre.on("mouseenter", "viirs-data", () => {
  //     mapLibre.getCanvas().style.cursor = "pointer";
  //   });
  //   mapLibre.on("mouseleave", "viirs-data", () => {
  //     mapLibre.getCanvas().style.cursor = "";
  //   });
  //   mapLibre.on("mouseenter", "modis-data", () => {
  //     mapLibre.getCanvas().style.cursor = "pointer";
  //   });
  //   mapLibre.on("mouseleave", "modis-data", () => {
  //     mapLibre.getCanvas().style.cursor = "";
  //   });
  //   mapLibre.on("mouseenter", "uncluster-hotspot", () => {
  //     mapLibre.getCanvas().style.cursor = "pointer";
  //   });
  //   mapLibre.on("mouseleave", "uncluster-hotspot", () => {
  //     mapLibre.getCanvas().style.cursor = "";
  //   });
  // };
  // const handleMouseClick = () => {
  //   mapLibre?.on("click", "viirs-data", (e: any) => {
  //     const coordinates = e.features[0].geometry.coordinates.slice();
  //     setFeaturePoint(e.features[0]);
  //     setCoordinatePoint(coordinates);
  //     setTimeout(() => {
  //       setOpenHotSpotStatus(true);
  //       setIsHideStatusBar(true);
  //     }, 300);
  //   });

  //   mapLibre?.on("click", "uncluster-hotspot", (e: any) => {
  //     const coordinates = e.features[0].geometry.coordinates.slice();
  //     setFeaturePoint(e.features[0]);
  //     setCoordinatePoint(coordinates);
  //     setTimeout(() => {
  //       setOpenHotSpotStatus(true);
  //       setIsHideStatusBar(false);
  //     }, 300);
  //   });

  //   mapLibre?.on("click", "modis-data", (e: any) => {
  //     const coordinates = e.features[0].geometry.coordinates.slice();
  //     setFeaturePoint(e.features[0]);
  //     setCoordinatePoint(coordinates);
  //     setTimeout(() => {
  //       setOpenHotSpotStatus(true);
  //       setIsHideStatusBar(true);
  //     }, 300);
  //   });
  // };
  // const getSurveyHotspot = async () => {
  //   try {
  //     const { data } = await axios.get(
  //       `${process.env.REACT_APP_API_VALLARIS}/survey/1.0/forms?name=*Hotspot*`,
  //       {
  //         headers: {
  //           "API-Key":
  //             "Azh14aMRVa9B3g4lDVZCCbGYhl37NWwS66K4VfyfaGEdbm2uF9yUklaMdG0NjKL5",
  //         },
  //       }
  //     );
  //     if (data) {
  //       if (data.forms) {
  //         setFormId(data.forms[0]._id);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const getReferenceSurvey = async (id: string) => {
  //   try {
  //     const { data } = await axios.get(
  //       `${process.env.REACT_APP_API_VALLARIS}/survey/1.0/forms/${id}/references/features`,
  //       {
  //         headers: {
  //           "API-Key":
  //             "Azh14aMRVa9B3g4lDVZCCbGYhl37NWwS66K4VfyfaGEdbm2uF9yUklaMdG0NjKL5",
  //         },
  //       }
  //     );
  //     if (data) {
  //       setSurveyReference(data.features);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const getResponseSurvey = async (id: string) => {
  //   try {
  //     const data = await axios.get(
  //       `${process.env.REACT_APP_API_VALLARIS}/survey/1.0/forms/${id}/responses/features?limit=10000`,
  //       {
  //         headers: {
  //           "API-Key":
  //             "Azh14aMRVa9B3g4lDVZCCbGYhl37NWwS66K4VfyfaGEdbm2uF9yUklaMdG0NjKL5",
  //         },
  //       }
  //     );
  //     if (data) {
  //       setSurveyResponse(data.data.features);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const handleFilterSurvey = (reference: any, response: any) => {
  //   let responsedSurvey = reference.filter((ref: any) => {
  //     let answer = response.find(
  //       (res: any) => res.properties["survey@refItemId"] === ref.id
  //     );
  //     return !answer;
  //   });

  //   if (responsedSurvey.length > 0) {
  //     let hotspot = hotspotSurvey;
  //     hotspot.features = [...responsedSurvey, ...response];
  //     setHotspotSurvey(hotspot);
  //   }
  // };

  const handleCalculateDate = () => {
    let currentDay = new Date();
    let thirtyDayAgo = new Date();
    thirtyDayAgo.setDate(currentDay.getDate() - 30);

    const unixTimestampToday = Math.floor(currentDay.getTime() / 1000);
    const unixTimestampThirtyDaysAgo = Math.floor(
      thirtyDayAgo.getTime() / 1000
    );

    setUnixDateToday(unixTimestampToday);
    setUnixDateThirtyAgo(unixTimestampThirtyDaysAgo);
  };

  useEffect(() => {
    handleCalculateDate();
  }, []);
  useEffect(() => {
    const map = new maplibregl.Map({
      container: mapContainer.current,
      style: `${process.env.REACT_APP_API_VALLARIS}/core/api/styles/1.0-beta/styles/64e5d885d0d61ab0e889ddd5?api_key=${process.env.REACT_APP_VALLARIS_API_KEY}`,
      zoom: zoom,
      maxZoom: 16,
      bounds: [
        [97.33396, 5.6252],
        [105.647, 20.47466],
      ],
      minZoom: 0,
      bearing: 0,
    });
    map.on("load", () => {
      setMapLibre(map);
      getCurrentPosition();
      let allLayer = map?.getStyle()?.layers;
      let layerData = _.filter(
        allLayer,
        (layer: any) => layer.metadata["vallaris:group"] === "layers"
      );
      let satellite = _.filter(
        allLayer,
        (layer: any) =>
          layer.metadata["vallaris:group"] === "Topography" ||
          layer.metadata["vallaris:group"] === "Hybrid" ||
          layer.metadata["vallaris:group"] === "Satellite"
      );
      setSatelliteLayer(satellite);
      setLayers(layerData);
    });

    return () => {
      if (map) {
        map?.remove();
      }
    };
  }, []);
  useEffect(() => {
    if (userJson) {
      setUser(JSON.parse(userJson));
    }
  }, [userJson]);
  useEffect(() => {
    if (!mapLibre) return;
    handleAddMeasurementLayer();
    return () => {
      mapLibre.off("click", handleMeasurementDistance);
      mapLibre.off("mousemove", handleMouseMove);
      mapLibre.getCanvas().style.cursor = "grab";
    };
  }, [measurementEnabled, geoMeasurePoint]);
  useEffect(() => {
    handleCalculateDistance(geoMeasureLine.geometry.coordinates);
  }, [geoMeasureLine]);
  useEffect(() => {
    let isHaveLayer = mapLibre?.getSource("current-position");
    if (!isHaveLayer) {
      if (currentPosition.length > 0 && mapLibre) {
        mapLibre?.addSource(`current-position`, {
          type: "geojson",
          data: geoCurrentPosition,
          cluster: false,
          clusterMaxZoom: 14,
          clusterRadius: 50,
        });

        mapLibre?.addLayer({
          id: `background-current-position`,
          type: "circle",
          source: `current-position`,
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": `#C34A25`,
            "circle-radius": 10,
            "circle-opacity": 0.2,
          },
        });

        mapLibre?.addLayer({
          id: `user-current-position`,
          type: "circle",
          source: `current-position`,
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": `#C34A25`,
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff",
          },
        });
      }
    }
  }, [mapLibre, geoCurrentPosition]);
  useEffect(() => {
    if (!mapLibre) return;
    handleCheckBaseMap(baseMapUrl);
    handleFilterMap(filterMap);
    handleCheckZoomLevel();
    handleCheckAngle();

    _.forEach(layers, (layer) => {
      mapLibre.on("mouseenter", layer.id, () => {
        mapLibre.getCanvas().style.cursor = "pointer";
      });
      mapLibre.on("mouseleave", layer.id, () => {
        mapLibre.getCanvas().style.cursor = "";
      });
      mapLibre.on("click", layer.id, (e: any) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        setFeaturePoint(e.features[0]);
        setCoordinatePoint(coordinates);
        setIsHideStatusBar(true);
        setTimeout(() => {
          setOpenHotSpotStatus(true);
        }, 300);
      });
    });

    return () => {
      _.forEach(layers, (layer) => {
        mapLibre.off("mouseenter", layer.id);
        mapLibre.off("mouseleave", layer.id);
        mapLibre.off("click", layer.id);
      });
    };
  }, [mapLibre, filterMap, baseMapUrl]);

  // useEffect(() => {
  //   getCurrentPosition();
  //   // getSurveyHotspot();
  // }, []);
  // useEffect(() => {
  //   if (formId.trim() !== "") {
  //     getReferenceSurvey(formId);
  //     getResponseSurvey(formId);
  //   }
  // }, [formId]);
  // useEffect(() => {
  //   if (surveyReference && surveyResponse) {
  //     handleFilterSurvey(surveyReference, surveyResponse);
  //   }
  // }, [surveyReference, surveyResponse]);
  // useEffect(() => {
  //   const map = new maplibregl.Map({
  //     container: mapContainer.current,
  //     style: baseMapUrl,
  //     zoom: zoom,
  //     maxZoom: 16,
  //     bounds: [
  //       [97.33396, 5.6252],
  //       [105.647, 20.47466],
  //     ],
  //     minZoom: 0,
  //     bearing: 0,
  //   });
  //   map.on("load", () => {
  //     setMapLibre(map);
  //   });

  //   return () => {
  //     if (map) {
  //       map.remove();
  //     }
  //   };
  // }, [baseMapUrl]);

  // useEffect(() => {
  //   handleSetFilterMaps(filterMap);
  // }, [filterMap]);

  // useEffect(() => {
  //   if (!mapLibre) return;
  //   mapLibre?.getLayer("viirs-data") && mapLibre?.removeLayer("viirs-data");
  //   mapLibre?.getSource("viirs-map") && mapLibre?.removeSource("viirs-map");
  //   mapLibre?.getLayer("modis-data") && mapLibre?.removeLayer("modis-data");
  //   mapLibre?.getSource("modis-map") && mapLibre?.removeSource("modis-map");

  //   mapLibre?.getImage("surveyIcon") && mapLibre?.removeImage("surveyIcon");
  //   mapLibre?.getLayer("uncluster-hotspot") &&
  //     mapLibre?.removeLayer("uncluster-hotspot");
  //   mapLibre?.getLayer("surveyIcon-layer") &&
  //     mapLibre?.removeLayer("surveyIcon-layer");
  //   mapLibre?.getSource("hotspot-survey") &&
  //     mapLibre?.removeSource("hotspot-survey");

  //   mapLibre.getLayer("provice-data") && mapLibre.removeLayer("provice-data");
  //   mapLibre.getSource("vector-provice") &&
  //     mapLibre.removeSource("vector-provice");

  //   mapLibre.getLayer("subdistric-data") &&
  //     mapLibre.removeLayer("subdistric-data");
  //   mapLibre.getSource("vector-subdistrict") &&
  //     mapLibre.removeSource("vector-subdistrict");

  //   mapLibre.getLayer("centroid_pv") && mapLibre.removeLayer("centroid_pv");
  //   mapLibre.getSource("vector-provice-label") &&
  //     mapLibre.removeSource("vector-provice-label");

  //   mapLibre.getLayer("centroid_ap") && mapLibre.removeLayer("centroid_ap");
  //   mapLibre.getSource("vector-district-label") &&
  //     mapLibre.removeSource("vector-district-label");

  //   mapLibre.getLayer("centroid_tb") && mapLibre.removeLayer("centroid_tb");
  //   mapLibre.getSource("vector-subdistrict-label") &&
  //     mapLibre.removeSource("vector-subdistrict-label");

  //   mapLibre.getLayer("distric-data") && mapLibre.removeLayer("distric-data");
  //   mapLibre.getSource("vector-district") &&
  //     mapLibre.removeSource("vector-district");

  //   mapLibre.getLayer("clusters") && mapLibre.removeLayer("clusters");
  //   mapLibre.getLayer("cluster-count") && mapLibre.removeLayer("cluster-count");
  //   mapLibre.getLayer("unclustered-point") &&
  //     mapLibre.removeLayer("unclustered-point");
  //   mapLibre.getSource("geojson-hotspot") &&
  //     mapLibre.removeSource("geojson-hotspot");

  //   mapLibre.getLayer("background-current-position") &&
  //     mapLibre.removeLayer("background-current-position");
  //   mapLibre.getLayer("uncluster-current-position") &&
  //     mapLibre.removeLayer("uncluster-current-position");
  //   mapLibre.getSource("current-position") &&
  //     mapLibre.removeSource("current-position");

  //   mapLibre?.loadImage("/icons/surveyIcon.png", (error: any, image: any) => {
  //     if (error) {
  //       console.log(error);
  //       return;
  //     }
  //     mapLibre?.addImage("surveyIcon", image);
  //     mapLibre?.addSource(`hotspot-survey`, {
  //       type: "geojson",
  //       data: hotspotSurvey,
  //       cluster: false,
  //       clusterMaxZoom: 14,
  //       clusterRadius: 50,
  //     });

  //     mapLibre?.addLayer({
  //       id: `uncluster-hotspot`,
  //       type: "circle",
  //       source: `hotspot-survey`,
  //       filter: ["any", ...filterConditionArea],
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 5,
  //       },
  //     });
  //   });

  //   mapLibre.on("zoom", () => {
  //     let currentZoom = mapLibre.getZoom().toFixed(0);
  //     if (mapLibre?.getLayer("surveyIcon-layer")) {
  //       if (currentZoom >= 9) {
  //         mapLibre?.setLayoutProperty(
  //           "surveyIcon-layer",
  //           "visibility",
  //           "visible"
  //         );
  //       } else {
  //         mapLibre?.setLayoutProperty("surveyIcon-layer", "visibility", "none");
  //       }
  //     } else {
  //       mapLibre?.addLayer({
  //         id: "surveyIcon-layer",
  //         type: "symbol",
  //         source: "hotspot-survey",
  //         filter: ["any", ...filterConditionArea],
  //         layout: {
  //           "icon-image": "surveyIcon",
  //           "icon-size": 0.29,
  //           "icon-offset": [230, 0],
  //         },
  //       });
  //     }
  //   });

  //   mapLibre?.addSource(`current-position`, {
  //     type: "geojson",
  //     data: geoCurrentPosition,
  //     cluster: false,
  //     clusterMaxZoom: 14,
  //     clusterRadius: 50,
  //   });

  //   mapLibre?.addLayer({
  //     id: `background-current-position`,
  //     type: "circle",
  //     source: `current-position`,
  //     filter: ["!", ["has", "point_count"]],
  //     paint: {
  //       "circle-color": `#C34A25`,
  //       "circle-radius": 10,
  //       "circle-opacity": 0.2,
  //     },
  //   });

  //   mapLibre?.addLayer({
  //     id: `uncluster-current-position`,
  //     type: "circle",
  //     source: `current-position`,
  //     filter: ["!", ["has", "point_count"]],
  //     paint: {
  //       "circle-color": `#C34A25`,
  //       "circle-radius": 4,
  //       "circle-stroke-width": 1,
  //       "circle-stroke-color": "#fff",
  //     },
  //   });

  //   if (filterMaps?.openVIIRS) {
  //     mapLibre.addSource("viirs-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/viirs?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "viirs-data",
  //       type: "circle",
  //       source: "viirs-map",
  //       "source-layer": "64eec838905f9e8c2857d2de",
  //       filter: [
  //         "all",
  //         ["any", ...filterConditionArea],
  //         [
  //           `${!filterMaps.openNORR && !filterMaps.openNPP ? "all" : "any"}`,
  //           ...filterSatelliteViirs,
  //         ],
  //       ],
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }
  //   if (filterMaps?.openModis) {
  //     mapLibre.addSource("modis-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/modis?token=${accessToken}`,
  //     });

  //     mapLibre.addLayer({
  //       id: "modis-data",
  //       type: "circle",
  //       source: "modis-map",
  //       "source-layer": "64ec7c0ff5c9ab0c1927f098",
  //       filter: ["any", ...filterConditionArea],
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }
  //   if (filterMaps?.openProvice) {
  //     mapLibre.addSource("vector-provice", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/province_hotspot?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "provice-data",
  //       type: "line",
  //       source: "vector-provice",
  //       "source-layer": "65124612bf9342f8b39ea15f",
  //       layout: {
  //         "line-join": "round",
  //         "line-cap": "round",
  //       },
  //       paint: {
  //         "line-color": "rgba(0, 0, 0, 1)",
  //         "line-width": 1,
  //       },
  //     });

  //     mapLibre.addSource("vector-provice-label", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/province_centroid?token=${accessToken}`,
  //     });

  //     mapLibre.addLayer({
  //       id: "centroid_pv",
  //       layout: {
  //         "text-field": " {pv_tn}",
  //         "text-font": ["Kanit"],
  //         "text-size": [
  //           "interpolate",
  //           ["linear"],
  //           ["zoom"],
  //           0,
  //           0,
  //           6,
  //           10,
  //           10,
  //           12,
  //           12,
  //           15,
  //           16,
  //           17,
  //           22,
  //           16,
  //         ],
  //         visibility: "visible",
  //       },
  //       maxzoom: 22,
  //       metadata: {
  //         "vallaris:group": "layers",
  //       },
  //       minzoom: 5.73,
  //       source: "vector-provice-label",
  //       "source-layer": "65163ee7bf9342f8b39eb83d",
  //       type: "symbol",
  //     });
  //   }
  //   if (filterMaps?.openDistrict) {
  //     mapLibre.addSource("vector-district", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/amphoe_hotspot?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "distric-data",
  //       type: "line",
  //       source: "vector-district",
  //       "source-layer": "65164adb0d7fbc8c5da51845",
  //       layout: {
  //         "line-join": "round",
  //         "line-cap": "round",
  //       },
  //       paint: {
  //         "line-color": "rgba(91, 0, 23, 1)",
  //         "line-width": 1,
  //       },
  //     });

  //     mapLibre.addSource("vector-district-label", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/amphoe_centroid?token=${accessToken}`,
  //     });

  //     mapLibre.addLayer({
  //       id: "centroid_ap",
  //       layout: {
  //         "text-field": " {ap_tn}",
  //         "text-font": ["Kanit"],
  //         "text-size": [
  //           "interpolate",
  //           ["linear"],
  //           ["zoom"],
  //           0,
  //           0,
  //           5,
  //           0,
  //           8,
  //           11,
  //           14,
  //           14,
  //           16,
  //           19,
  //           22,
  //           21,
  //         ],
  //         visibility: "visible",
  //       },
  //       maxzoom: 22,
  //       metadata: {
  //         "vallaris:group": "layers",
  //       },
  //       minzoom: 8.29,
  //       source: "vector-district-label",
  //       "source-layer": "651641157b3777849a13c8a1",
  //       type: "symbol",
  //     });
  //   }
  //   if (filterMaps?.openSubDistrict) {
  //     mapLibre.addSource("vector-subdistrict", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/tambon_hotspot?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "subdistric-data",
  //       type: "line",
  //       source: "vector-subdistrict",
  //       "source-layer": "651245cfb62fa0117c8a6565",
  //       layout: {
  //         "line-join": "round",
  //         "line-cap": "round",
  //       },
  //       paint: {
  //         "line-color": "rgba(86, 83, 83, 0.71)",
  //         "line-width": 1,
  //       },
  //     });

  //     mapLibre.addSource("vector-subdistrict-label", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/tambon_centroid?token=${accessToken}`,
  //     });

  //     mapLibre.addLayer({
  //       id: "centroid_tb",
  //       layout: {
  //         "text-field": "  {tb_tn}",
  //         "text-font": ["Kanit"],
  //         "text-size": [
  //           "interpolate",
  //           ["linear"],
  //           ["zoom"],
  //           0,
  //           0,
  //           5,
  //           0,
  //           8,
  //           8,
  //           10,
  //           10,
  //           16,
  //           17,
  //           22,
  //           16,
  //         ],
  //         visibility: "visible",
  //       },
  //       maxzoom: 22,
  //       metadata: {
  //         "vallaris:group": "layers",
  //       },
  //       minzoom: 10.58,
  //       source: "vector-subdistrict-label",
  //       "source-layer": "651640f87b3777849a13c8a0",
  //       type: "symbol",
  //     });
  //   }

  //   handleCheckZoomLevel();
  //   handleMouseMoveSatelliteData();
  //   handleMouseClick();
  // }, [mapLibre, filterMaps, geoCurrentPosition, hotspotSurvey]);

  return (
    <div className="relative ">
      <div className="absolute left-0 xl:-left-6">
        <div
          className=" w-screen xl:w-[calc(100vw_-_220px)] 2xl:w-[calc(100vw_-_260px)] h-screen"
          ref={mapContainer}
        />
      </div>
      <div
        className="absolute block xl:hidden left-4 top-4 bg-primary-contrast w-11 h-11 p-3 rounded-[10px] border-[1px] border-gray-1  cursor-pointer"
        onClick={() => toggleNavbar(!isOpen)}
      >
        <GiHamburgerMenu color="#C34A25" size={18} />
      </div>
      {unixDateToday !== undefined && unixDateThirtyAgo !== undefined && (
        <div className="absolute left-4 xl:left-2 top-20 xl:top-4">
          <p className="text-sm font-normal">
            ข้อมูลตั้งแต่วันที่ {formatUnixDateToThai(unixDateThirtyAgo)} -{" "}
            {formatUnixDateToThai(unixDateToday)}
          </p>
        </div>
      )}
      <div className="absolute right-8 top-4">
        <UserProfile user={user} />
      </div>
      <div className="absolute z-10 right-8 top-[96px] ">
        <MapsSearch onSelectLocation={handleSelectPosition} />
      </div>
      <div className="absolute right-8 top-[232px]" onClick={handleRotateMap}>
        <Compass degrees={angle} />
      </div>
      <div className="absolute right-8 top-[280px] ">
        <BaseMaps onMeasure={handleMeasureMentToggle} />
      </div>
      <div className="absolute right-8 top-[328px] ">
        <ZoomMaps zoom={zoom} onZoom={handleZoomMap} />
      </div>
      <div className="absolute right-8 top-[392px] ">
        <CurrentPosition onClick={geoLocationControll} />
      </div>
      {measurementEnabled && (
        <div className="absolute right-8 top-[552px] ">
          <MeasureDistance
            onRollBack={handlePopMeasurePoint}
            distance={distance}
          />
        </div>
      )}
      <HotSpotStatus
        open={openHotSpotStatus}
        hideStatusBar={isHideStatusBar}
        features={featurePoint}
        coordinate={coordinatePoint}
        onClose={() => setOpenHotSpotStatus(false)}
      />
    </div>
  );
}

export default Maps;
